import { render, staticRenderFns } from "./my-report-builder.vue?vue&type=template&id=fd894548&scoped=true"
import script from "./my-report-builder.vue?vue&type=script&lang=js"
export * from "./my-report-builder.vue?vue&type=script&lang=js"
import style0 from "./my-report-builder.vue?vue&type=style&index=0&id=fd894548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd894548",
  null
  
)

export default component.exports